export default __webpack_public_path__ + "static/media/pukeko-rental.6304d460.png";